import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/destination.css';

export default class Guruvayur extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview'
    };
  }

  render() {
    const attractions = [
      {
        name: "Guruvayur Sri Krishna Temple",
        image: "/assets/img/guruvayur.jpg",
        description: "One of the most sacred and important pilgrimage sites in South India, dedicated to Lord Krishna. Known as the 'Dwarka of the South'.",
        highlight: "Sacred Pilgrimage",
        bestTime: "Morning/Evening",
        duration: "2-3 Hours",
        tip: "Visit during early morning for a peaceful darshan"
      },
      {
        name: "Mammiyur Temple",
        image: "/assets/img/mammiyur-temple.jpg",
        description: "An ancient Shiva temple located near Guruvayur Temple, believed to be older than the main temple. Devotees visit here before worshipping at Guruvayur.",
        highlight: "Ancient Shiva Temple",
        bestTime: "Morning",
        duration: "1 Hour",
        tip: "Part of the Guruvayur pilgrimage circuit"
      },
      {
        name: "Punnathur Kotta Elephant Sanctuary",
        image: "/assets/img/punnathur-kotta.jpg",
        description: "A unique elephant sanctuary housing over 50 elephants dedicated to the Guruvayur Temple. Watch elephants being fed and bathed.",
        highlight: "Elephant Sanctuary",
        bestTime: "Morning",
        duration: "1-2 Hours",
        tip: "Visit during feeding time (10:00 AM)"
      },
      {
        name: "Guruvayur Devaswom Museum",
        image: "/assets/img/guruvayur-museum.jpg",
        description: "A museum showcasing the rich history, artifacts, and cultural heritage of the Guruvayur Temple including ancient ornaments and temple models.",
        highlight: "Cultural Heritage",
        bestTime: "Afternoon",
        duration: "1 Hour",
        tip: "Closed on Mondays"
      },
      {
        name: "Chavakkad Beach",
        image: "/assets/img/chavakkad-beach.jpg",
        description: "A serene beach located 5 km from Guruvayur, perfect for sunset views and peaceful walks. Less crowded and pristine.",
        highlight: "Scenic Beach",
        bestTime: "Sunset",
        duration: "1-2 Hours",
        tip: "Perfect for evening relaxation"
      },
    //   {
    //     name: "Venugopala Krishna Temple",
    //     image: "/assets/img/venugopala-temple.jpg",
    //     description: "A beautiful temple dedicated to Lord Krishna playing the flute, known for its stunning architecture and peaceful atmosphere.",
    //     highlight: "Architectural Beauty",
    //     bestTime: "Morning",
    //     duration: "30-45 mins",
    //     tip: "Part of the temple circuit"
    //   },
      {
        name: "Palayur Church",
        image: "/assets/img/palayur-church.jpg",
        description: "One of the oldest churches in India, believed to be established by St. Thomas in 52 AD. A significant Christian pilgrimage site.",
        highlight: "Historic Church",
        bestTime: "Morning",
        duration: "1 Hour",
        tip: "Historic architecture worth seeing"
      }
    //   {
    //     name: "Elephant Camp at Punnathur Kotta",
    //     image: "/assets/img/elephant-camp.jpg",
    //     description: "Witness the daily routine of temple elephants including bathing, feeding, and training sessions in a traditional setting.",
    //     highlight: "Elephant Interaction",
    //     bestTime: "Morning",
    //     duration: "2 Hours",
    //     tip: "Best time is during bathing hours"
    //   }
    ];

    const experiences = [
      {
        title: "Temple Pilgrimage",
        description: "Seek blessings at the sacred Guruvayur Sri Krishna Temple",
        icon: "fas fa-pray"
      },
      {
        title: "Elephant Encounters",
        description: "Interact with over 50 temple elephants at the sanctuary",
        icon: "fas fa-paw"
      },
      {
        title: "Cultural Tours",
        description: "Explore museums and traditional Kerala architecture",
        icon: "fas fa-landmark"
      },
      {
        title: "Beach Relaxation",
        description: "Unwind at the pristine Chavakkad Beach",
        icon: "fas fa-umbrella-beach"
      }
    ];

    const quickInfo = [
      { label: "Location", value: "Thrissur District, Kerala", icon: "fas fa-map-marker-alt" },
      { label: "Best Time to Visit", value: "September to March", icon: "fas fa-calendar-alt" },
      { label: "Nearest Airport", value: "Cochin International Airport (85 km)", icon: "fas fa-plane" },
      { label: "Nearest Railway", value: "Guruvayur Railway Station (2 km)", icon: "fas fa-train" },
      { label: "Famous For", value: "Sri Krishna Temple, Elephants", icon: "fas fa-hands-praying" },
      { label: "Language", value: "Malayalam, English, Hindi", icon: "fas fa-language" }
    ];

    const templeFacts = [
      { label: "Deity", value: "Lord Krishna (Balakrishnan)" },
      { label: "Temple Area", value: "6.5 acres" },
      { label: "Main Festival", value: "Kumbham (February-March)" },
      { label: "Temple Pond", value: "Rudratheertham" }
    ];

    const festivals = [
      {
        name: "Kumbham Festival",
        month: "February-March",
        description: "The main temple festival featuring elephant processions, traditional music, and fireworks"
      },
      {
        name: "Krishna Janmashtami",
        month: "August-September",
        description: "Celebration of Lord Krishna's birthday with special poojas and festivities"
      },
      {
        name: "Ekadasi",
        month: "November-December",
        description: "The most important day at Guruvayur with thousands of devotees attending"
      },
      {
        name: "Vishu",
        month: "April",
        description: "Malayalam New Year celebration with Vishukani and special offerings"
      }
    ];

    const poojaTimings = [
      { time: "3:00 AM", pooja: "Nirmalyam" },
      { time: "3:20 AM", pooja: "Malar Nivedyam" },
      { time: "4:00 AM", pooja: "Usha Pooja" },
      { time: "7:15 AM", pooja: "Palabhishekam" },
      { time: "11:00 AM", pooja: "Pantheeradi Pooja" },
      { time: "12:00 PM", pooja: "Ucha Pooja" },
      { time: "4:30 PM", pooja: "Seeveli" },
      { time: "7:30 PM", pooja: "Deeparadhana" },
      { time: "9:00 PM", pooja: "Athazha Pooja" }
    ];

    return (
      <div className="dest-destination-page">
        {/* Hero Section */}
        <div className="destination-hero">
          <div className="dest-hero-overlay"></div>
          <div className="dest-hero-background">
            <img src="/assets/img/guruvayur-temple-bg.jpg" alt="Guruvayur Temple" />
          </div>
          <div className="dest-hero-content">
            <div className="dest-hero-badge">
              <span>Dwarka of the South</span>
            </div>
            <h1 className="dest-hero-title">Guruvayur</h1>
            <p className="dest-hero-subtitle">
              Where divine grace flows through the sacred abode of Lord Krishna
            </p>
            <div className="dest-hero-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>Thrissur District, Kerala, India</span>
            </div>
          </div>
          <div className="dest-hero-scroll">
            <span>Scroll to explore</span>
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="dest-intro-section">
          <Grid>
            <Row>
              <Col xs={12} md={7} className="dest-intro-text">
                <h2 className="dest-section-title">Welcome to Guruvayur</h2>
                <p className="dest-intro-description">
                  Guruvayur, often called the 'Dwarka of the South', is one of the most sacred 
                  pilgrimage towns in Kerala. The Sri Krishna Temple here is the heart and soul 
                  of the town, drawing millions of devotees from across the world.
                </p>
                <p className="dest-intro-description">
                  The town is named after the Guru (Brihaspati) and Vayu (Lord of Winds), who 
                  are believed to have installed the deity. The temple is known for its strict 
                  traditions, powerful vibrations, and the famous elephant sanctuary.
                </p>
                <div className="dest-highlight-box">
                  <i className="dest-fas fa-star"></i>
                  <span>Did You Know? Guruvayur Temple has over 50 elephants dedicated to the temple, housed at the Punnathur Kotta Elephant Sanctuary.</span>
                </div>
              </Col>
              <Col xs={12} md={5} className="dest-quick-info">
                <h3>Quick Facts</h3>
                <div className="dest-info-grid">
                  {quickInfo.map((info, index) => (
                    <div key={index} className="dest-info-card">
                      <div className="dest-info-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="dest-info-content">
                        <span className="dest-info-label">{info.label}</span>
                        <span className="dest-info-value">{info.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Experiences Section */}
        <div className="dest-experiences-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Experiences in Guruvayur</h2>
            <p className="dest-section-subtitle">
              Spiritual and cultural experiences in the temple town
            </p>
          </div>
          <Grid>
            <Row className="experiences-grid">
              {experiences.map((exp, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="experience-col">
                  <div className="experience-card">
                    <div className="exp-icon">
                      <i className={exp.icon}></i>
                    </div>
                    <h4 className="exp-title">{exp.title}</h4>
                    <p className="exp-description">{exp.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Temple Section */}
        <div className="guruvayur-temple-section">
          <div className="temple-overlay-guruvayur"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="temple-content-guruvayur">
                <div className="temple-badge-guruvayur">Sacred Abode</div>
                <h2 className="temple-title-guruvayur">Sri Krishna Temple</h2>
                <p className="temple-description-guruvayur">
                  The Guruvayur Sri Krishna Temple is dedicated to Lord Krishna as a young boy 
                  (Balakrishnan). The temple's architecture is a fine example of Kerala style, 
                  with a gold-plated flagpost and a towering deepasthambam (lamp tower).
                </p>
                <p className="temple-description-guruvayur">
                  The main deity, known as Guruvayurappan, is worshipped with great devotion. 
                  The temple is known for its powerful vibrations and is believed to fulfill 
                  the wishes of sincere devotees.
                </p>
                <div className="temple-facts-guruvayur">
                  {templeFacts.map((fact, index) => (
                    <div key={index} className="temple-fact">
                      <span className="fact-label">{fact.label}</span>
                      <span className="fact-value">{fact.value}</span>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Pooja Timings Section */}
        <div className="pooja-section">
          <Grid>
            <div className="section-header">
              <h2 className="section-title-centered">Daily Pooja Timings</h2>
              <p className="section-subtitle">
                Experience the divine rituals at the temple
              </p>
            </div>
            <Row className="pooja-grid">
              {poojaTimings.map((pooja, index) => (
                <Col xs={12} sm={6} md={4} key={index} className="pooja-col">
                  <div className="pooja-card">
                    <div className="pooja-time">{pooja.time}</div>
                    <div className="pooja-name">{pooja.pooja}</div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Attractions Section */}
        <div className="dest-attractions-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Top Attractions in Guruvayur</h2>
            <p className="dest-section-subtitle">
              Discover the sacred and scenic wonders of the temple town
            </p>
          </div>

          <Grid>
            <Row className="dest-attractions-grid">
              {attractions.map((attraction, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="attraction-col">
                  <div className="dest-attraction-card">
                    <div className="dest-card-image">
                      <img src={attraction.image} alt={attraction.name} />
                      <div className="dest-card-overlay">
                        <span className="dest-highlight-tag">{attraction.highlight}</span>
                      </div>
                    </div>
                    <div className="dest-card-content">
                      <h3 className="dest-attraction-name">{attraction.name}</h3>
                      <p className="dest-attraction-description">{attraction.description}</p>
                      <div className="dest-card-footer">
                        <div className="dest-time-info">
                          <span className="dest-best-time">
                            <i className="far fa-calendar"></i>
                            {attraction.bestTime}
                          </span>
                          <span className="dest-duration">
                            <i className="far fa-clock"></i>
                            {attraction.duration}
                          </span>
                        </div>
                        <div className="dest-travel-tip">
                          <i className="fas fa-lightbulb"></i>
                          <span>{attraction.tip}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Elephant Sanctuary Section */}
        <div className="elephant-section">
          <div className="elephant-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="elephant-content">
                <div className="elephant-badge">Elephant Sanctuary</div>
                <h2 className="elephant-title">Punnathur Kotta</h2>
                <p className="elephant-description">
                  Punnathur Kotta is a unique elephant sanctuary housing over 50 elephants 
                  dedicated to the Guruvayur Temple. Spread across 5 acres, this is the largest 
                  elephant sanctuary in the world for temple elephants.
                </p>
                <p className="elephant-description">
                  Visitors can watch elephants being fed, bathed, and trained. The majestic 
                  elephants, adorned with traditional ornaments, are a sight to behold. The 
                  sanctuary offers an unforgettable experience for animal lovers.
                </p>
                <div className="elephant-features">
                  <div className="feature">
                    <i className="fas fa-paw"></i>
                    <span>50+ Temple Elephants</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-bath"></i>
                    <span>Daily Bathing Sessions</span>
                  </div>
                  <div className="feature">
                    <i className="fas fa-apple-alt"></i>
                    <span>Feeding Time Viewing</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Festivals Section */}
        <div className="festivals-section-guruvayur">
          <Grid>
            <div className="section-header">
              <h2 className="section-title-centered">Festivals & Celebrations</h2>
              <p className="section-subtitle">
                Experience the vibrant festivals of Guruvayur
              </p>
            </div>
            <Row className="festivals-grid-guruvayur">
              {festivals.map((festival, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="festival-col-guruvayur">
                  <div className="festival-card-guruvayur">
                    <div className="festival-month">{festival.month}</div>
                    <h3 className="festival-name">{festival.name}</h3>
                    <p className="festival-description">{festival.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Travel Tips Section */}
        <div className="dest-tips-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Travel Tips for Guruvayur</h2>
              <p className="dest-section-subtitle">Make the most of your spiritual journey</p>
            </div>
            <Row className="dest-tips-grid">
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <h4>Best Time to Visit</h4>
                  <p>September to March offers pleasant weather for temple visits.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-tshirt"></i>
                  </div>
                  <h4>Dress Code</h4>
                  <p>Traditional attire required. Men: Dhoti, Women: Saree or traditional dress.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-ticket-alt"></i>
                  </div>
                  <h4>Special Darshan</h4>
                  <p>Book special entry tickets to avoid long queues during peak season.</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-utensils"></i>
                  </div>
                  <h4>Must Try</h4>
                  <p>Temple prasadam, local Kerala cuisine, and traditional snacks.</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* CTA Section */}
        <div className="dest-cta-section">
          <div className="dest-cta-content">
            <h3>Seek Divine Blessings at Guruvayur</h3>
            <p>Let us help you plan your spiritual journey</p>
            <Link to="/contact" className="dest-cta-button">
              Plan Your Pilgrimage
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}